import joinClasses from "helpers/joinClasses";

export function Input({ className, ...props }) {
  return <input className={joinClasses(className, "")} {...props} />;
}
